// src/contexts/ChatContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { initSocket, disconnectSocket } from '../utils/socket';

const ChatContext = createContext({});

export const ChatProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const [onlineUsers, setOnlineUsers] = useState(new Set());
  const [typingUsers, setTypingUsers] = useState({});

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const newSocket = initSocket(token);
      setSocket(newSocket);

      newSocket.on('user_status_change', ({ userId, online }) => {
        setOnlineUsers(prev => {
          const newSet = new Set(prev);
          if (online) newSet.add(userId);
          else newSet.delete(userId);
          return newSet;
        });
      });

      newSocket.on('user_typing', ({ userId, connectionId, isTyping }) => {
        setTypingUsers(prev => ({
          ...prev,
          [connectionId]: isTyping ? userId : null
        }));
      });

      return () => {
        disconnectSocket();
      };
    }
  }, []);

  const value = {
    socket,
    onlineUsers,
    typingUsers,
    isUserOnline: (userId) => onlineUsers.has(userId),
    isUserTyping: (connectionId) => typingUsers[connectionId],
  };

  return (
    <ChatContext.Provider value={value}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChat = () => useContext(ChatContext);